var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVioletCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0C3.36452 0 0 3.36443 0 7.49996C0 11.6355 3.36452 15 7.5 15C11.6355 15 15 11.6355 15 7.49996C15 3.36443 11.6356 0 7.5 0ZM11.8066 6.23315L7.09476 10.945C6.89442 11.1453 6.62809 11.2556 6.34479 11.2556C6.06148 11.2556 5.79516 11.1453 5.59481 10.945L3.19337 8.54357C2.99302 8.34322 2.88267 8.0769 2.88267 7.79359C2.88267 7.51021 2.99302 7.24389 3.19337 7.04354C3.39364 6.8432 3.65996 6.73285 3.94334 6.73285C4.22665 6.73285 4.49305 6.8432 4.69332 7.04362L6.34471 8.69492L10.3065 4.73313C10.5069 4.53278 10.7732 4.42251 11.0565 4.42251C11.3398 4.42251 11.6061 4.53278 11.8065 4.73313C12.2202 5.14682 12.2202 5.81962 11.8066 6.23315Z",
    fill: "#6F52E1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVioletCheck);
export default __webpack_public_path__ + "static/media/violet-check.a0b688071402723056b3ed787c5ea387.svg";
export { ForwardRef as ReactComponent };